<template>
  <div class="container">
    <div class="bar-chart">
      <pie-source></pie-source>
    </div>
  </div>
</template>

<script>
import PieSource from './pieSource.vue'

export default {
  components: {
    PieSource
  },
}
</script>

<style scoped>
.container {
  margin-top: 1%;
  background-color: #ffffff;
  width: 99.5%;
}

.title {
  padding-top: 10px;
  margin: 1%;
}

.line-chart {
  width: 100%;
  height: 100%;
}

.bar-chart {
  height: 100%;
  width: 100%;
  background-color: #ffffff;
}
</style>
